<template lang="pug">
    el-dialog(:title="title",width="95%",:visible.sync='visible' :modal-append-to-body='false')
        el-form(:model="coachForm",:inline="false", :rules="rules", ref="coachForm" label-width="120px")
            el-card(shadow="never")
                div(slot="header")
                    font(style="font-weight: bold;font-size:18px;") 教练详情
                div.labelStyle
                    el-form-item(label="姓名:" prop="name")
                        font {{coachForm.name}}
                    el-form-item(label="手机号码:" prop="phone")
                        font {{coachForm.phone}}
                    el-form-item(label="身份证号码:" prop="cardNum")
                        font {{coachForm.cardNum}}
                    el-form-item(label="地区:" prop="cityName")
                        font {{coachForm.provinceName}}&nbsp; (省) {{coachForm.cityName}} (市)
                    el-form-item(label="等级:" prop="leve")
                        font {{coachForm.leve}}
                    el-form-item(label="级别" prop="coachLevel")
                        font {{coachForm.coachLevel}}
                    el-form-item(label="性别:" prop="sex")
                        font(v-if="coachForm.sex === 0") 男
                        font(v-if="coachForm.sex === 1") 女
                    el-form-item(label="邮箱:" prop="email")
                        font {{coachForm.email}}
                        //- 迭代二
                    el-form-item(label="授课时数:" prop="classHours")
                        font {{coachForm.classHours}}
                    el-form-item(label="教练资质:" prop="intelligence")
                        font {{coachForm.intelligence}}
                    el-form-item(label="教练标签:" prop="label")
                        font {{coachForm.label}}
                    el-form-item(label="教练头像:" prop="headPortrait")
                        font
                          <div>
                          <img :src='coachForm.headPortrait'>
                          </div>
                    el-form-item(label="运动经历:" prop="sportsExperience")
                        font
                          <div v-html='coachForm.sportsExperience'>
                          </div>

                    //- el-form-item(label="add教练员照片:" prop="cardNum")
                    //-     font {{coachForm.email}}
                    //- el-form-item(label="add授课时数:" prop="cardNum")
                    //-     font {{coachForm.email}}
                    //- el-form-item(label="add运动经历:" prop="cardNum")
                    //-     font {{coachForm.email}}
                    //- el-form-item(label="add教练资质:" prop="cardNum")
                    //-     font {{coachForm.email}}
                    //- el-form-item(label="add课时费标准:" prop="cardNum")
                    //-     font {{coachForm.email}}
                    //- el-form-item(label="add教练标签:" prop="cardNum")
                    //-     font {{coachForm.email}}
        span.dialog-footer(slot="footer")
            el-button(@click="visible=false") 返 回

</template>
<script>
export default {
  data () {
    return {
      type: '',
      title: '查看详情',
      tableData: [
        {
          dataName: '注册会员',
          type: 1,
          price: 0.0
        },
        {
          dataName: '初始会员',
          type: 2,
          price: 0.0
        },
        {
          dataName: '荣誉会员',
          type: 3,
          price: 0.0
        }
      ],
      coachForm: {
        id: null,
        ctId: '',
        matchName: '',
        orgId: '',
        city: '',
        province: '',
        placeId: '',
        ctType: '',
        applySize: '',
        projectType: null,
        level: '',
        bench: '1',
        applyDate: [],
        matchSignStartTime: '',
        matchSignEndTime: '',
        matchStartTime: '',
        imgList: '',
        gameDescription: '',
        matchDescription: '',
        imgDetailList: '',
        repeatSign: '0',
        genderLimit: '2',
        ageLimit: '',
        ageMinMen: undefined,
        ageMaxMen: undefined,
        ageMinWomen: undefined,
        ageMaxWomen: undefined,
        scoreMin: '',
        ctRefundList: [],
        byx1: '',
        verifyReason: ''
      },
      visible: false,
      rules: {
        verifyReason: [
          { required: true, message: '审核意见不能为空!', trigger: 'blur' },
          { max: 200, message: '审核意见长度不能超过200个字符!' }
        ]
      }
    }
  },
  methods: {
    init (id, type) {
      this.title = '查看详情'
      this.coachForm.id = id || null
      this.visible = true
      this.type = type
      if (type == 'release') {
        this.title = '审核发布'
      }
      this.coachForm.verifyReason = ''
      //回选
      if (this.coachForm.id) {
        this.$http({
          url: this.$http.adornUrl(`/pxCoach/getId/` + this.coachForm.id),
          method: 'get'
        }).then((data) => {
          if (data && data.code === 0) {
            this.coachForm = data.bean
          }
        })
      }
    },
    releaseSubmit (type) {
      this.$refs['coachForm'].validate((valid) => {
        if (valid) {
          if (type === 2) {
            this.$confirm('是否发布比赛?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
              .then(async () => {
                this.updateState(type)
              })
              .catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消发布'
                })
              })
          } else if (type === 5) {
            this.updateState(type)
          }
        }
      })
    },
    updateState (type) {
      this.$http({
        url: this.$http.adornUrl(`/ctCompetition/updateStatus`),
        method: 'post',
        params: this.$http.adornParams({
          status: type,
          id: this.coachForm.id,
          verifyReason: this.coachForm.verifyReason
        })
      }).then((data) => {
        if (data && data.code === 0) {
          this.$message({
            message: '审核成功',
            type: 'success',
            duration: 1500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        } else {
          this.$message.error(data.msg)
        }
      })
    }
  }
}
</script>
<style>
.el-table__header {
  width: 100% !important;
}
.el-table__body {
  width: 100% !important;
}
* {
  margin: 0;
}
</style>
